import React, { useEffect,useRef } from "react"
import Label from "../atoms/Label"
import { Desktop, Mobile } from "../util/breakpoints"
import { markdownToJSX } from "../../util/transforms"
import ReadMore from "../molecules/ReadMore"
import Image from "../atoms/Image"
import contentfulRichText from "../util/contentfulRichText"
import useWindowSize from "../util/useWindowSize"


export default ({
  className,
  label,
  title,
  subtitle,
  isInverted,
  image,
  isRedLabel,
  text: inputText,
  mobileRatio = "3-2",
  desktopRatio,
  link,
  translations,
  fitImageOnMobile
}) => {

  // The text can be either rich text or string
  const text = typeof inputText === "string" ? <p>{ inputText }</p> : contentfulRichText( inputText )
  
  const mobileImageEl = useRef()
  const windowSize = useWindowSize()

  const fitImageVertically = () => {

    const ratio = image.file.details.image.height / image.file.details.image.width
    const maxItemHeight = windowSize.height - 128
    const galleryWidth = mobileImageEl.current.offsetWidth
    const newHeight = ratio * galleryWidth > maxItemHeight ? maxItemHeight : ratio * galleryWidth

    // only fit images that are taller than wider
    if( ratio <= 1 )
      return
    
    mobileImageEl.current.style.height = newHeight + 'px'
    mobileImageEl.current.classList.remove( 'u-object-fit--3-2' )

  }


  const imageIsLoadedInDom = () => {
    if( !mobileImageEl.current.children[0] )
      return false
    return true    
  }

  const fitImageVerticallyIfLoaded = () => {
    
    // on desktop we don't have anything in this ref
    if( !mobileImageEl.current )
      return

    // if explicity set then don't adjust
    if( fitImageOnMobile && fitImageOnMobile == "No, do not adjust the image" ) {
      return
    }

    if( imageIsLoadedInDom() ) {
      fitImageVertically()
    } else {
      setTimeout(() => {
        fitImageVerticallyIfLoaded()
      },10)
    }
  }

  // calculate whenever window size changes
  useEffect(()=>{    
    // i think we get a race condition for the render without the timeout and we don't have access
    // to the image-wrapper > img unless we wait a tick
    setTimeout( () => {
      fitImageVerticallyIfLoaded()
    },1)

  },[ windowSize.width, windowSize.height ])

  return (
    <>
      <Mobile>
        <section className={ `u-section-spacing${ className ? " " + className : "" }` }>
          <div className="o-image-text">
            <div className="o-image-text__content">
              <Label isRed={ isRedLabel } text={ label }/>
              <h2>{ markdownToJSX(title) }</h2>
            </div>
            { image &&
              <div className={ "u-object-fit u-object-fit--" + mobileRatio } ref={ mobileImageEl }>
                <Image className="u-object-fit__media" image={ image }/>
              </div>
            }
            <div className="o-image-text__content">
              { text }
              { link && <ReadMore isRed text={ link.title } link={ link } translations={ translations }/> }
            </div>
          </div>
        </section>
      </Mobile>
      <Desktop>
        <section className={ "u-container u-section-spacing" + (className ? " " + className : "") }>
          <div className={ "o-image-text" + (isInverted ? " o-image-text--inverted" : "") }>
            { image &&
              <div className="o-image-text__item">
                  <div className={ "u-object-fit" + (desktopRatio ? (" u-object-fit--" + desktopRatio) : "") }>
                    <Image className="u-object-fit__media" image={ image }/>
                </div>
              </div>
            }
            <div className="o-image-text__item">
              <div className="o-image-text__content">
                <Label isRed={ isRedLabel } text={ label }/>
                <h2>{ markdownToJSX(title) }</h2>
                { subtitle && <Label classes="o-image-text__subtitle" text={ subtitle }/> }
                { text }
                { link && <ReadMore isRed text={ link.title } link={ link } translations={ translations }/> }
              </div>
            </div>
          </div>
        </section>
      </Desktop>
    </>
  )

}
